<template>
    <!--<div v-bind:class="{ 'm-featured-posts hero' : resultItem.IsFirst }" v-bind:style="[resultItem.IsFirst ? {'background': 'url(' +  resultItem.Image.Url + ')'} : '']">-->
    <div>    
    <div class="m-listingitem">
            <div class="e-image" v-if="!hideImage">
                <a :href="returnUrl(resultItem.Link)" v-if="resultItem.Link">
                    <thumbnail-image :photo-id="resultItem.Image.Id" v-if="resultItem.Image"></thumbnail-image>
                </a>
            </div>
            <div class="e-text full">
                <div class="top">
                    <p class="contentcategory">Blog post</p>

                    <h3><a :href="returnUrl(resultItem.Link)">{{resultItem.Heading}}</a></h3>

                    <p class="date">
                        Published {{formatDate(resultItem.Date.DateTime)}}
                        <span v-if="resultItem.Content.BlogDetails.AuthorUrl">by <a :href="resultItem.Content.BlogDetails.AuthorUrl">{{resultItem.Content.BlogDetails.AuthorName}}</a></span>
                        in <a :href="resultItem.Content.BlogDetails.TopicUrl">{{resultItem.Content.BlogDetails.TopicName}}</a>
                    </p>

                    <p :title="resultItem.Summary">{{truncate(resultItem.Summary)}}</p>
                </div>

                <div class="buttons myhie">
                    <a :href="returnUrl(resultItem.Link)"
                       class="btn btn-green"
                       v-if="resultItem.Link">Find out more</a>

                    <span class="read-time">{{resultItem.Content.BlogDetails.ReadTime}} min read</span>

                    <profile-actions :page-id="resultItem.Id.toString()"></profile-actions>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Globals from '@/globals.js'
    import ProfileActions from '@/components/Utils/profile-actions'
    import ThumbnailImage from '@/components/Utils/thumbnail-image'

    import { globalMixin } from '@/mixins/globalMixin.js'
    import { format, toDate } from '@/utils/date.js'
    import { truncate } from '@/utils/strings.js'

    export default {
        components: {
            ProfileActions,
            ThumbnailImage
        },

        methods: {
            formatDate(date) {
                return format(toDate(date), Globals.dateFormatUi)
            },

            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            }
        },

        mixins: [globalMixin],

        props: {
            resultItem: {
                required: true,
                type: Object
            },
            hideImage: {
                required: false,
                type: Boolean
            },
        }
    }
</script>